<template>
  <div v-cloak>
    <SimpleNav />
    <!-- {{this.$route.path}} -->
    <div class="row">
      <div class="col s12">
        <ul class="tabs flow-text">
          <li class="tab col s6">
            <!-- <a class="active" href="#test1">Enterprise Projects</a> -->
              <router-link v-bind:class="[this.$route.path.includes('Enterprise') ? 'active' : '']" to="/Works/Enterprise" exact>Enterprise</router-link>
          </li>
          <li class="tab col s6">
              <router-link v-bind:class="[this.$route.path.includes('Class') ? 'active' : '']" :to="{name: 'ClassProjectsPage'}" exact>Class</router-link>
            <!-- <a href="#test2">Class Projects</a> -->
          </li>
        </ul>
      </div>

    </div>
        <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import SimpleNav from "@/components/SimpleNav.vue";
import ClassProj from "@/components/ClassProjects.vue";
import EnterpriseProj from "@/components/EnterpriseProjects.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Works",
  components: {
    ClassProj,
    EnterpriseProj,
    SimpleNav,
    Footer
  },
  data() {
    return {

    };
  },

  mounted() {
    var el = document.querySelectorAll(".tabs");
    var instance = M.Tabs.init(el, {});
  }
};
</script>

<style scoped>

.card-image {
  height: 250px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.card {
  height: 400px;
  border-radius: 20px;
}


</style>
